/**
 * airan-ntn — Doppler Compensation xApp
 * Updates Doppler compensation based on UE velocity and satellite motion
 */

import { XAppBase } from './XAppBase.js';
import { E2KpmReport, E2RcAction, XAppDecision } from '../types.js';

export class DopplerCompXApp extends XAppBase {
  private lastReports: Map<number, E2KpmReport> = new Map();

  constructor(enabled: boolean = true) {
    super('doppler-comp', enabled);
  }

  processKpmReport(report: E2KpmReport): void {
    this.lastReports.set(report.gnbId, report);
  }

  decisionCycle(): XAppDecision {
    const start = performance.now();
    const actions: E2RcAction[] = [];

    for (const [gnbId, report] of this.lastReports) {
      if (Math.abs(report.dopplerShift) > 1000) {
        actions.push({
          type: 'DOPPLER_COMP_UPDATE',
          targetId: gnbId,
          payload: { compensationHz: -report.dopplerShift, method: 'frequency_shift' },
          priority: this.config.priority,
          timestamp: Date.now()
        });
        if (report.elevation < 20) {
          actions.push({
            type: 'TIMING_ADVANCE_UPDATE',
            targetId: gnbId,
            payload: { advanceUs: Math.abs(report.dopplerShift) * 0.1 },
            priority: this.config.priority,
            timestamp: Date.now()
          });
        }
      }
    }

    const latency = performance.now() - start;
    this.recordDecision(latency);

    return { actions, confidence: 0.9, latencyMs: latency };
  }

  getRequiredSubscription(): { eventTriggers: string[]; reportStyle: string } {
    return {
      eventTriggers: this.config.requiredEventTriggers,
      reportStyle: this.config.requiredReportStyle
    };
  }
}